<template>
  <div class="back">
    <!-- 预加载Image -->
    <div v-show="false">
      <img v-for="(item,i) in this.pageList" :key="i" :src="item.url" />
    </div>
    <!-- 目录遮罩 -->
    <div class="catalog" ref="homePage" @click="catalogShow = false" v-show="catalogShow  == true">
      <div class="catalog_con" @click.stop="catalogShow = true">
        <!-- 关闭按钮 -->
        <div class="closeBtn" @click.stop="catalogShow = false">
          <el-button icon="el-icon-close" circle></el-button>
        </div>
        <!-- 目录 -->
        <div class="catalog_p">
          <div
            v-for="(item,i) in catalogList"
            :key="i"
            :class="item.isChoose == true?'catalog_p_item2':'catalog_p_item'"
            @click.stop="catalogItem(item.pageCount)"
          >{{item.name}}</div>
        </div>
      </div>
    </div>
    <!-- ppt -->
    <div>
      <transition name="el-zoom-in-center">
        <img :src="imageSrc" alt class="pptImage" v-show="imageShow" @load="imageLoad" />
      </transition>
    </div>

    <!-- 按钮组 -->
    <div class="posiTop">
      <div class @click="toIndex">
        <div>
          <el-button type="warning" icon="el-icon-s-home" circle></el-button>
        </div>
      </div>
      <div class="secondBtn" @click="catalogShow = true">
        <div>
          <el-button type="primary" icon="el-icon-notebook-2" circle></el-button>
        </div>
      </div>
      <div class="secondBtn" @click="phoneFun">
        <div>
          <el-button type="info" icon="el-icon-phone" circle></el-button>
        </div>
      </div>
    </div>

    <div class="posiBot">
      <div class @click="previousPage">
        <div>
          <el-button type="info" icon="el-icon-caret-top" circle :disabled="disabledPre"></el-button>
        </div>
      </div>

      <div class="secondBtn" @click="nextPage">
        <div>
          <el-button type="info" icon="el-icon-caret-bottom" circle :disabled="disabledNext"></el-button>
        </div>
      </div>
    </div>

    <!-- 电话弹窗 -->
    <el-dialog title="联系我们" :visible.sync="phoneShow" width="90%">
      <div class="phone_div" v-for="(item,i) in phoneList" :key="i" @click="callPhone(i)">
        <div><i :class="item.icon"></i><span>{{item.name}}</span></div>
        <div><span class="yellowColor">电话：{{item.num}}</span></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {},
  data() {
    return {
      phoneList:[{name:"技术支持",num:"13387262847",icon:"el-icon-edit"},{name:"商务合作",num:"15572703500",icon:"el-icon-phone-outline"}],
      phoneShow: false,
      disabledPre: false,
      disabledNext: false,
      clientHeight: "",
      imageSrc: require("../../assets/images/ppt/1.jpg"),
      catalogShow: false,
      imageShow: true,
      pageList: [
        {
          url: require("../../assets/images/ppt/1.jpg"),
          isChoose: true,
          pageCount: 1
        },
        {
          url: require("../../assets/images/ppt/2.jpg"),
          isChoose: false,
          pageCount: 2
        },
        {
          url: require("../../assets/images/ppt/3.jpg"),
          isChoose: false,
          pageCount: 3
        },
        {
          url: require("../../assets/images/ppt/4.jpg"),
          isChoose: false,
          pageCount: 4
        },
        {
          url: require("../../assets/images/ppt/5.jpg"),
          isChoose: false,
          pageCount: 5
        },
        {
          url: require("../../assets/images/ppt/6.jpg"),
          isChoose: false,
          pageCount: 6
        },
        {
          url: require("../../assets/images/ppt/7.jpg"),
          isChoose: false,
          pageCount: 7
        },
        {
          url: require("../../assets/images/ppt/8.jpg"),
          isChoose: false,
          pageCount: 8
        },
        {
          url: require("../../assets/images/ppt/9.jpg"),
          isChoose: false,
          pageCount: 9
        },
        {
          url: require("../../assets/images/ppt/10.jpg"),
          isChoose: false,
          pageCount: 10
        },
        {
          url: require("../../assets/images/ppt/11.jpg"),
          isChoose: false,
          pageCount: 11
        },
        {
          url: require("../../assets/images/ppt/12.jpg"),
          isChoose: false,
          pageCount: 12
        },
        {
          url: require("../../assets/images/ppt/13.jpg"),
          isChoose: false,
          pageCount: 13
        },
        {
          url: require("../../assets/images/ppt/14.jpg"),
          isChoose: false,
          pageCount: 14
        },
        {
          url: require("../../assets/images/ppt/15.jpg"),
          isChoose: false,
          pageCount: 15
        },
        {
          url: require("../../assets/images/ppt/16.jpg"),
          isChoose: false,
          pageCount: 16
        },
        {
          url: require("../../assets/images/ppt/17.jpg"),
          isChoose: false,
          pageCount: 17
        },
        {
          url: require("../../assets/images/ppt/18.jpg"),
          isChoose: false,
          pageCount: 18
        },
        {
          url: require("../../assets/images/ppt/19.jpg"),
          isChoose: false,
          pageCount: 19
        },
         {
          url: require("../../assets/images/ppt/20.jpg"),
          isChoose: false,
          pageCount: 20
        }
      ],
      catalogList: [
        { name: "首页", isChoose: true, pageCount: 1 },
        { name: "保康县综合演练情况介绍", isChoose: false, pageCount: 3 },
        { name: "指挥中心融合通信系统介绍 ", isChoose: false, pageCount: 6 },
        { name: "现场应急通讯设备介绍 ", isChoose: false, pageCount: 9 },
        { name: "科尔融合通讯系统特色", isChoose: false, pageCount: 17 }
      ]
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };

    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    callPhone(i){
       window.location.href = `tel:`+this.phoneList[i].num
    },
    phoneFun() {
      this.phoneShow = true;
    },
    imageLoad(e) {
      console.log(e);
      setTimeout(() => {
        this.imageShow = true;
      }, 500);
    },
    backTop() {
      // const that = this;
      // let timer = setInterval(() => {
      //   let ispeed = Math.floor(-that.scrollTop / 2);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     that.scrollTop + ispeed;
      //   if (that.scrollTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },

    // 上一页
    previousPage() {
      this.imageShow = false;
      var url = this.imageSrc;
      for (var i = 0; i < this.pageList.length; i++) {
        if (this.pageList[i].url == url) {
          if (i > 0) {
            // console.log(i);
            this.imageSrc = this.pageList[i - 1].url;
            for (var l = 0; l < this.catalogList.length; l++) {
              this.catalogList[l].isChoose = false;
              if (i <= 2) {
                this.catalogList[0].isChoose = true;
              } else if (i >= 2 && i < 6) {
                this.catalogList[1].isChoose = true;
              } else if (i >= 6 && i < 9) {
                this.catalogList[2].isChoose = true;
              } else if (i >= 9 && i < 17) {
                this.catalogList[3].isChoose = true;
              } else if (i >= 17) {
                this.catalogList[4].isChoose = true;
              }
            }
          } else {
            console.log("indexPage");
            this.$message("这是首页");
          }
        }
      }
      this.backTop();
      // setTimeout(() => {
      //   this.imageShow = true;
      // }, 500);
    },
    // 下一页
    nextPage() {
      this.imageShow = false;
      var url = this.imageSrc;
      for (var i = 0; i < this.pageList.length; i++) {
        if (this.pageList[i].url == url) {
          console.log(i);
          if (i < this.pageList.length - 1) {
            this.imageSrc = this.pageList[i + 1].url;
            for (var l = 0; l < this.catalogList.length; l++) {
              this.catalogList[l].isChoose = false;
              if (i < 1) {
                this.catalogList[0].isChoose = true;
              } else if (i >= 1 && i < 4) {
                this.catalogList[1].isChoose = true;
              } else if (i >= 4 && i <= 6) {
                this.catalogList[2].isChoose = true;
              } else if (i >= 7 && i <= 14) {
                this.catalogList[3].isChoose = true;
              } else if (i >= 15) {
                this.catalogList[4].isChoose = true;
              }
            }
          } else {
            console.log("lastPage");
            // this.$message("这是最后一页了");
          }
        }
      }
      this.backTop();
      // setTimeout(() => {
      //   this.imageShow = true;
      // }, 500);
    },
    catalogItem(c) {
      this.imageShow = false;
      console.log(c);
      for (var i = 0; i < this.catalogList.length; i++) {
        this.catalogList[i].isChoose = false;
        if (this.catalogList[i].pageCount == c) {
          this.catalogList[i].isChoose = true;
        }
      }
      for (var i = 0; i < this.pageList.length; i++) {
        this.pageList[i].isChoose = false;
        if (this.pageList[i].pageCount == c) {
          this.imageSrc = this.pageList[i].url;
          this.pageList[i].isChoose = true;
        }
      }
      this.catalogShow = false;
      setTimeout(() => {
        this.imageShow = true;
      }, 500);
      console.log(this.imageShow);
    },
    toIndex() {
      this.$router.push({ path: "/" });
    },
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight + "px";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.pptImage {
  width: 100%;
  z-index: 888;
}
.indexBtn {
  position: fixed;
  top: 5%;
  right: 3%;
}
.catalogBtn {
  position: fixed;
  top: 12%;
  right: 3%;
}
.previousBtn {
  position: fixed;
  bottom: 5%;
  right: 3%;
}
.nextBtn {
  position: fixed;
  bottom: 12%;
  right: 3%;
}
.catalog {
  width: 100%;
  background-color: rgba(00, 00, 00, 0.5);
  position: fixed;
  z-index: 999;
}
.catalog_con {
  width: 90%;
  height: 100%;
  margin-left: 10%;
  background-color: rgba(33, 33, 33, 1);
}
.closeBtn {
  position: absolute;
  top: 3%;
  right: 3%;
}
.catalog_p {
  width: 80%;
  margin: 0 auto;
  color: #fff;
  font-size: 22px;
  padding-top: 15%;
}
.catalog_p_item {
  margin-top: 20px;
}
.catalog_p_item2 {
  margin-top: 20px;
  color: #f98329;
}
.posiTop {
  position: fixed;
  top: 5%;
  right: 5%;
}
.posiBot {
  position: fixed;
  bottom: 5%;
  right: 5%;
}
.secondBtn {
  margin-top: 15px;
}
.phone_div{
  width: 90%;
  margin: 0 auto;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4;
  margin-top: 10px;
}
.yellowColor{
  color: #f98329;
}
</style>



// WEBPACK FOOTER //
// src/components/phone/phone_ppt.vue